/**
 * Removes the /$tenantSlug route parameter placeholder from a route path.
 * Used to convert TanStack Router paths (e.g. "/$tenantSlug/dashboard") to relative paths (e.g. "/dashboard").
 */
export function removeTenantSlugParam(path: string): string {
    const stripped = path.replace("/$tenantSlug", "");
    return stripped === "" ? "/" : stripped;
}
